import { render, staticRenderFns } from "./whiteIp.vue?vue&type=template&id=dfdff0c8&"
import script from "./whiteIp.vue?vue&type=script&lang=js&"
export * from "./whiteIp.vue?vue&type=script&lang=js&"
import style0 from "./whiteIp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports